import script from "./QuickActionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickActionCard.vue?vue&type=script&setup=true&lang=js"

import "./QuickActionCard.vue?vue&type=style&index=0&id=56bba2dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bba2dc"]])

export default __exports__